module.exports = __webpack_public_path__ + "media/no-article-found.5073e92f.wav";